import { PageTitle } from '../../../_metronic/layout/core'
import {
  TilesWidget7,
} from '../../../_metronic/partials/widgets'
import { TilesWidget6 } from '../../../_metronic/partials/widgets/tiles/TilesWidget6'
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { DashboardChart } from '../../../_metronic/partials/widgets/charts/DashboardChart';
import { Tr } from '../../../_metronic/i18n/Tr';
import { Link } from 'react-router-dom';

const DashboardPage = () => {
  const t = Tr()
  var categoryId = sessionStorage.getItem("categoryId");
  const [actionDetail, setActionDetails] = useState({}) as any

  return (
    <>
      <div className="d-flex justify-content-end my-2">
        {
          categoryId == '1' && (
            <Link
              className='btn bg-white btn-active-light-primary cursor-pointer'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              to="../addhotelbasicinfo/"
            >
              + {t('Create Listings Now')}
            </Link>
          )
        }
        {
          categoryId == '3' && (
            <Link
              className='btn bg-white btn-active-light-primary cursor-pointer'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              to="../addrestaurantbasicinfo/"
            >
              + {t('Create Listings Now')}
            </Link>
          )
        }
        {
          categoryId == '4' && (
            <Link
              className='btn bg-white btn-active-light-primary cursor-pointer'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              to="../addspacebasicinfo/"
            >
              + {t('Create Listings Now')}
            </Link>
          )
        }
        {
          categoryId == '5' && (
            <Link
              className='btn bg-white btn-active-light-primary cursor-pointer'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              to="../addtourpackagebasicinfo/"
            >
              + {t('Create Listings Now')}
            </Link>
          )
        }
        {
          categoryId == '7' && (
            <Link
              className='btn bg-white btn-active-light-primary cursor-pointer'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              to="../addcarrentalbasicinfo/"
            >
              + {t('Create Listings Now')}
            </Link>
          )
        }
      </div>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <div className=' gx-5 gx-xl-8 mb-5 mb-xl-8'>
            <TilesWidget6
              className='card-xxl-stretch bg-white'
              svgIcon=''
              titleClass=''
              descriptionClass='text-dark fw-bold'
              iconClass=''
              totalCompletedBooking={actionDetail['totalCompletedBooking']}
              totalCancelledBooking={actionDetail['totalCancelledBooking']}
              totalBooking={actionDetail['totalBooking']}
              description={t('Total Bookings')}
            />
          </div>
          <div className=' gx-5 gx-xl-8 mb-5 mb-xl-8'>
            {
              categoryId == '0' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Hotel')}
                />
              )
            }
            {
              categoryId == '1' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Hotel')}
                />
              )
            }
            {
              categoryId == '3' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Cafe & Restaurant')}
                />
              )
            }
            {
              categoryId == '4' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Space Rental')}
                />
              )
            }
            {
              categoryId == '5' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Tour Package')}
                />
              )
            }
            {
              categoryId == '7' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Car Rentals')}
                />
              )
            }
            {
              categoryId == '8' && (

                <TilesWidget7
                  className='card-xxl-stretch bg-white'
                  svgIcon='element-11'
                  titleClass=''
                  descriptionClass='text-dark fw-bold'
                  iconClass=''
                  title={actionDetail['totalAction']}
                  description={t('No. Of Leisure & Ticket')}
                />
              )
            }
          </div>
          <div className=' gx-5 gx-xl-8 mb-5 mb-xl-8'>
            <TilesWidget7
              className='card-xxl-stretch bg-white'
              svgIcon='user'
              titleClass=''
              descriptionClass='text-dark fw-bold'
              iconClass=''
              title={actionDetail['totalVisitor']}
              description={t('No. Of Visitor')}
            />
          </div>

        </div>

        <div className="col-xl-8">
          <DashboardChart className='card-xl-stretch mb-xl-8' setActionDetails={setActionDetails} />
        </div>
      </div>
    </>
  )
}

const DashboardWrapper = () => {
  const t = Tr()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('Dashboard')}</PageTitle>
      <ToastContainer />
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
